
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire41fc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire41fc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $92Z4w = parcelRequire("92Z4w");

var $kc9hG = parcelRequire("kc9hG");

var $epS55 = parcelRequire("epS55");
const $ce77af30fc9a6e63$var$CURRENCY = "SGD";
const $ce77af30fc9a6e63$var$App = (()=>{
    const getPaymentData = ()=>{
        const urlParams = new URLSearchParams(window.location.search);
        return {
            planName: urlParams.get("plan") || "",
            planPrice: urlParams.get("price") || 0,
            redirectUrl: urlParams.get("redirectUrl") || "",
            sessionId: urlParams.get("sessionId") || "",
            sessionData: urlParams.get("sessionData") || "",
            ssoId: urlParams.get("ssoId") || ""
        };
    };
    const displayPlanInfo = ({ planName: planName, planPrice: planPrice })=>{
        const planNameEl = document.getElementById("planName");
        if (planNameEl && planName) planNameEl.textContent = planName;
        const planPriceEl = document.getElementById("planPrice");
        if (planPriceEl && planPrice) planPriceEl.textContent = `${$ce77af30fc9a6e63$var$CURRENCY} ${parseFloat(planPrice).toFixed(2)}`;
    };
    return {
        init: ()=>{
            const { planName: planName, planPrice: planPrice, redirectUrl: redirectUrl, sessionData: sessionData, sessionId: sessionId, ssoId: ssoId } = getPaymentData();
            // Mixpanel
            (0, $epS55.isMixpanelEnabled)() && (0, (/*@__PURE__*/$parcel$interopDefault($kc9hG))).initMixpanel(ssoId);
            displayPlanInfo({
                planName: planName,
                planPrice: planPrice
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($92Z4w))).init({
                currency: $ce77af30fc9a6e63$var$CURRENCY,
                planPrice: planPrice,
                redirectUrl: redirectUrl,
                sessionData: sessionData,
                sessionId: sessionId
            });
        }
    };
})();
$ce77af30fc9a6e63$var$App.init();


//# sourceMappingURL=index.fa66c653.js.map
